<template>
  <div class="container">
    <div class="commonPad card1">
      <div class="header commonCardWidth">
        <img
          src="@/assets/images/logo.png"
          class="logo"
          alt=""
          style="margin-left: -2px"
        />
        <el-dropdown placement="bottom" @command="changeLan">
          <div class="languageContainer">
            {{ lang == "en" ? "English" : "Tiếng Việt" }}
            <span class="el-dropdown-link">
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </div>
          <el-dropdown-menu slot="dropdown" style="width: 148px">
            <el-dropdown-item command="en">English</el-dropdown-item>
            <el-dropdown-item command="vi">Tiếng Việt</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <img src="@/assets/images/recruit/bg1.png" class="cardBg1 pcShow" />
      <img src="@/assets/images/recruit/bg2.png" class="bgImg mobileShow" />
      <div class="leftArea commonCardWidth">
        <div class="titleText0">{{ textObj[lang].title }}</div>
        <div class="titleText">
          {{ textObj[lang].hotRecruit }}
        </div>
        <div class="cardContent card1Width2">
          {{ textObj[lang].titleDesc }}
        </div>
        <img
          src="@/assets/images/recruit/card1.png"
          class="rightImg2 mobileShow"
        />
        <!-- <div class="commonLine">
          <img src="@/assets/images/recruit/phone.png" class="lineImg" />
          0921929291
        </div> -->
        <div class="commonLine">
          <img src="@/assets/images/recruit/zalo.png" class="lineImg" />
          0921929291
        </div>
        <div class="commonLine">
          <img src="@/assets/images/recruit/email.png" class="lineImg" />
          {{ email }}
        </div>
      </div>
      <img src="@/assets/images/recruit/card1_1.png" class="rightImg1 pcShow" />
    </div>

    <online-service/>

    <div class="commonPad">
      <div class="commonCardWidth">
        <el-row :gutter="isMobile ? 33 : 43">
          <el-col :span="8">
            <div
              class="threeBox"
              @click="active = 0"
              :class="{ active: active == 0 }"
            >
              <img
                src="@/assets/images/recruit/tab1.png"
                class="boxImg pcShow"
              />
              <img
                src="@/assets/images/recruit/tab1.png"
                class="boxImg mobileShow"
                v-if="active == 0"
              />
              <img
                src="@/assets/images/recruit/tab1_1.png"
                class="boxImg mobileShow"
                v-else
              />
              <div class="boxTitle">{{ textObj[lang].recruitingAnchors }}</div>
              <div class="boxDesc pcShow">{{ textObj[lang].tab1.desc }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div
              class="threeBox"
              @click="active = 1"
              :class="{ active: active == 1 }"
            >
              <img
                src="@/assets/images/recruit/tab2.png"
                class="boxImg pcShow"
              />
              <img
                src="@/assets/images/recruit/tab2.png"
                class="boxImg mobileShow"
                v-if="active == 1"
              />
              <img
                src="@/assets/images/recruit/tab2_1.png"
                class="boxImg mobileShow"
                v-else
              />
              <div class="boxTitle">{{ textObj[lang].recruitingGuild }}</div>
              <div class="boxDesc pcShow">{{ textObj[lang].tab2.desc }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div
              class="threeBox"
              @click="active = 2"
              :class="{ active: active == 2 }"
            >
              <img
                src="@/assets/images/recruit/tab3.png"
                class="boxImg pcShow"
              />
              <img
                src="@/assets/images/recruit/tab3.png"
                class="boxImg mobileShow"
                v-if="active == 2"
              />
              <img
                src="@/assets/images/recruit/tab3_1.png"
                class="boxImg mobileShow"
                v-else
              />
              <div class="boxTitle">{{ textObj[lang].agentCooperation }}</div>
              <div class="boxDesc pcShow">{{ textObj[lang].tab3.desc }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="commonPad" v-if="active == 0">
      <div class="commonCardWidth">
        <div class="bigTitle0">{{ textObj[lang].recruitingAnchors }}</div>
        <div class="bigDesc">{{ textObj[lang].tab1.secTitle }}</div>
        <div class="tabBody">
          <img src="@/assets/images/recruit/tab1Big.png" class="tabBigImg" />
          <div class="tabBodyRight">
            <div class="rightItem">
              <div class="tabBodyTitle">
                {{ textObj[lang].tab1.thirdTitle1 }}
              </div>
              <div class="tabBodyText">
                {{ textObj[lang].tab1.thirdContent1 }}
              </div>
            </div>
            <div>
              <div class="tabBodyTitle">
                {{ textObj[lang].tab1.thirdTitle2 }}
              </div>
              <div class="tabBodyText">
                {{ textObj[lang].tab1.thirdContent2 }}
              </div>
              <div class="tabBodyText">
                {{ textObj[lang].tab1.thirdContent3 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="commonPad" v-if="active == 1">
      <div class="commonCardWidth">
        <div class="bigTitle0">{{ textObj[lang].recruitingGuild }}</div>
        <div class="bigDesc">{{ textObj[lang].tab2.secTitle }}</div>
        <div class="tabBody">
          <img src="@/assets/images/recruit/tab2Big.png" class="tabBigImg" />
          <div class="tabBodyRight">
            <div class="rightItem">
              <div class="tabBodyTitle">
                {{ textObj[lang].tab2.thirdTitle1 }}
              </div>
              <div class="tabBodyText">
                {{ textObj[lang].tab2.thirdContent1 }}
              </div>
            </div>
            <div>
              <div class="tabBodyTitle">
                {{ textObj[lang].tab2.thirdTitle2 }}
              </div>
              <div class="tabBodyText">
                {{ textObj[lang].tab2.thirdContent2 }}
              </div>
              <div class="tabBodyText">
                {{ textObj[lang].tab2.thirdContent3 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="commonPad" v-if="active == 2">
      <div class="commonCardWidth">
        <div class="bigTitle0">{{ textObj[lang].agentCooperation }}</div>
        <div class="bigDesc">{{ textObj[lang].tab3.secTitle }}</div>
        <div class="tabBody">
          <img src="@/assets/images/recruit/tab3Big.png" class="tabBigImg" />
          <div class="tabBodyRight">
            <div class="rightItem">
              <div class="tabBodyTitle">
                {{ textObj[lang].tab3.thirdTitle1 }}
              </div>
              <div class="tabBodyText">
                {{ textObj[lang].tab3.thirdContent1 }}
              </div>
            </div>
            <div>
              <div class="tabBodyTitle">
                {{ textObj[lang].tab3.thirdTitle2 }}
              </div>
              <div class="tabBodyText">
                {{ textObj[lang].tab3.thirdContent2 }}
              </div>
              <div class="tabBodyText">
                {{ textObj[lang].tab3.thirdContent3 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 我们的优势 -->
    <div class="commonPad ourAdvantage">
      <div class="commonCardWidth">
        <div class="bigTitle">{{ textObj[lang].youshi.title }}</div>
        <el-row :gutter="20">
          <el-col :span="isMobile ? 24 : 8">
            <div class="advantageItem">
              <img
                src="@/assets/images/recruit/adv_icon1.png"
                class="advImg pcShow"
              />
              <img
                src="@/assets/images/recruit/adv_icon4.png"
                class="advImg mobileShow"
              />
              <div class="advBody">
                <div class="advantageTitle">
                  {{ textObj[lang].youshi.advantage1 }}
                </div>
                <div class="advantageDesc">
                  {{ textObj[lang].youshi.advantage1Desc }}
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="isMobile ? 24 : 8">
            <div class="advantageItem">
              <img
                src="@/assets/images/recruit/adv_icon2.png"
                class="advImg pcShow"
              />
              <img
                src="@/assets/images/recruit/adv_icon5.png"
                class="advImg mobileShow"
              />
              <div class="advBody advBody2">
                <div class="advantageTitle">
                  {{ textObj[lang].youshi.advantage2 }}
                </div>
                <div class="advantageDesc">
                  {{ textObj[lang].youshi.advantage2Desc }}
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="isMobile ? 24 : 8">
            <div class="advantageItem">
              <img
                src="@/assets/images/recruit/adv_icon3.png"
                class="advImg pcShow"
              />
              <img
                src="@/assets/images/recruit/adv_icon6.png"
                class="advImg mobileShow"
              />
              <div class="advBody">
                <div class="advantageTitle">
                  {{ textObj[lang].youshi.advantage3 }}
                </div>
                <div class="advantageDesc">
                  {{ textObj[lang].youshi.advantage3Desc }}
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 合伙人要求 -->
    <div class="commonPad partnerRequire">
      <div class="commonCardWidth">
        <div class="bigTitle">{{ textObj[lang].partner.title }}</div>
        <el-row :gutter="30" class="partnerRow">
          <el-col :span="isMobile ? 24 : 12">
            <div class="partnerItem partnerItem2">
              <img
                src="@/assets/images/recruit/partner1.png"
                class="advImg pcShow"
              />
              <img
                src="@/assets/images/recruit/partner1_1.png"
                class="advImg mobileShow"
              />
              <div class="partnerBody">
                <div class="partnerTitle">
                  {{ textObj[lang].partner.partner1 }}
                </div>
                <div class="partnerDesc">
                  {{ textObj[lang].partner.partner1Desc }}
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="isMobile ? 24 : 12">
            <div class="partnerItem">
              <img
                src="@/assets/images/recruit/partner2.png"
                class="advImg pcShow"
              />
              <img
                src="@/assets/images/recruit/partner2_1.png"
                class="advImg mobileShow"
              />
              <div class="partnerBody partnerBody2">
                <div class="partnerTitle">
                  {{ textObj[lang].partner.partner2 }}
                </div>
                <div class="partnerDesc">
                  {{ textObj[lang].partner.partner2Desc }}
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="30">
          <el-col :span="isMobile ? 24 : 12">
            <div class="partnerItem partnerItem2">
              <img
                src="@/assets/images/recruit/partner3.png"
                class="advImg pcShow"
              />
              <img
                src="@/assets/images/recruit/partner3_1.png"
                class="advImg mobileShow"
              />
              <div class="partnerBody">
                <div class="partnerTitle">
                  {{ textObj[lang].partner.partner3 }}
                </div>
                <div class="partnerDesc">
                  {{ textObj[lang].partner.partner3Desc }}
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="isMobile ? 24 : 12">
            <div class="partnerItem">
              <img
                src="@/assets/images/recruit/partner4.png"
                class="advImg pcShow"
              />
              <img
                src="@/assets/images/recruit/partner4_1.png"
                class="advImg mobileShow"
              />
              <div class="partnerBody partnerBody2">
                <div class="partnerTitle">
                  {{ textObj[lang].partner.partner4 }}
                </div>
                <div class="partnerDesc">
                  {{ textObj[lang].partner.partner4Desc }}
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 如何成为合伙人 -->
    <div class="commonPad howToBePartner">
      <div class="commonCardWidth">
        <div class="bigTitle">{{ textObj[lang].how.title }}</div>
        <div class="howPartnerBody">
          <div class="partnerBox">
            <img src="@/assets/images/recruit/how1.png" class="howImg" />
            <div class="howPartnerTitle">{{ textObj[lang].how.step1 }}</div>
          </div>
          <div class="partnerBox">
            <img src="@/assets/images/recruit/how2.png" class="howImg" />
            <div class="howPartnerTitle">{{ textObj[lang].how.step2 }}</div>
          </div>
          <div class="partnerBox">
            <img src="@/assets/images/recruit/how3.png" class="howImg" />
            <div class="howPartnerTitle">{{ textObj[lang].how.step3 }}</div>
          </div>
          <div class="mobileShow oneLine" />
          <div class="partnerBox">
            <img src="@/assets/images/recruit/how4.png" class="howImg" />
            <div class="howPartnerTitle">{{ textObj[lang].how.step4 }}</div>
          </div>
          <div class="partnerBox">
            <img src="@/assets/images/recruit/how5.png" class="howImg" />
            <div class="howPartnerTitle">{{ textObj[lang].how.step5 }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="commonPad peopleContent">
      <img src="@/assets/images/recruit/peopleBg.png" class="bgImg pcShow" />
      <img
        src="@/assets/images/recruit/peopleBg2.png"
        class="bgImg mobileShow"
      />
      <div class="peopleBody">
        <div class="bigTitle0">{{ textObj[lang].people.title }}</div>
        <div class="bigDesc0">{{ textObj[lang].people.desc }}</div>
      </div>
      <div
        v-for="(item, index) in headList"
        :key="item.img"
        :class="[`avatar-` + (index + 1), 'avatar']"
      >
        <img :src="item.img" class="avatarImg" />
      </div>
    </div>

    <div class="footer">
      <div class="commonCardWidth footerBody">
        <div>@ 2025 yame Technology Pte. Ltd.</div>
        <div>
          <i class="el-icon-message" />
          {{ email }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import OnlineService from "./OnlineService.vue";
export default {
  name: "recruit",
  components: {
    OnlineService,
  },
  data() {
    return {
      email: 'YAME669@gmail.com',
      textObj: {
        en: {
          title: "Yame Live",
          hotRecruit: "Hot Recruitment", // 火热招募
          titleDesc:
            "Precise traffic, exclusive operation docking, intelligent operation, super high rebate ratio. Join the Yame ecosystem and create unlimited possibilities.",
          contactUs: "Contact Us", // 联系我们
          recruitingAnchors: "Anchors Recruiting", // 主播招募
          recruitingGuild: "Guild Recruiting", // 公会招募
          agentCooperation: "Agent Cooperation", // 代理合作
          tab1: {
            desc: "Super high rebate & new talent guarantee & anchor tilt",
            secTitle:
              "Industry-leading rebate policy, guaranteed anchor income, new anchor traffic recommendation weighting, and rapid cold start",
            thirdTitle1: "Streamer Cooperation Model",
            thirdContent1:
              "- Initiative Contact for Joining: Enjoy resource support.",
            thirdTitle2: "Streamer Support",
            thirdContent2:
              "- Traffic Support: Access to recommendation and exposure resources.",
            thirdContent3:
              "- Training Support: Guidance on live-streaming skills and content creation.",
          },
          tab2: {
            desc: "Massive users & team commission & exclusive operation",
            secTitle:
              "Massive users with precise recommendation, continuous and efficient fan growth, and the larger the team commission guild, the higher the income",
            thirdTitle1: "Guild Cooperation Model",
            thirdContent1:
              "- Initiative Contact for Joining: Bulk registration and management of streamers under the guild, enjoying exclusive platform policies and resource benefits.",
            thirdTitle2: "Guild Support",
            thirdContent2:
              "- Higher Revenue Share: Exclusive profit-sharing ratios for teams.",
            thirdContent3:
              "- Priority Access: Fast-track approval for new streamers and priority participation in platform events.",
          },
          tab3: {
            desc: "Traffic inclusion & team commission & exclusive operation",
            secTitle:
              "The larger the team commission guild, the higher the income. High quality institutions have 1V1 exclusive operation docking, and daily problems are handled quickly",
            thirdTitle1: "Agent Cooperation Model",
            thirdContent1:
              "- Initiative Contact for Joining: Bulk registration and management of streamers under the agent, enjoying exclusive platform policies and resource benefits.",
            thirdTitle2: "Agent Support",
            thirdContent2:
              "- Higher Revenue Share: Additional rebates upon reaching performance targets.",
            thirdContent3:
              "- Priority Access: Fast-track approval for new streamers and priority participation in platform events.",
          },
          youshi: {
            title: "Our Advantages",
            advantage1: "Cooperation system",
            advantage1Desc:
              "Established a robust partnership system with automatic settlement, fund transfer, and worry-free experience upon transaction.",
            advantage2: "Development",
            advantage2Desc:
              "The team members have profound R&D capabilities and the product iteration is fast",
            advantage3: "Have resources",
            advantage3Desc:
              "Having Internet resources can help outstanding partners grow rapidly",
          },
          partner: {
            title: "Partner Requirements",
            partner1: "Value consistency",
            partner1Desc:
              "I identify with the product value and cultural concepts of Yame and am willing to have a long-term cooperation with YAME",
            partner2: "Business reputation",
            partner2Desc:
              "The enterprise has a good business reputation and word-of-mouth. The company has formal documents.",
            partner3: "Industry experience",
            partner3Desc:
              "Have some experience in the new media industry and be enthusiastic about participating in it",
            partner4: "Resource assets",
            partner4Desc:
              "Possessing abundant channel resources such as enterprises, customers, and institutions, or having rich industry experience",
          },
          how: {
            title: "How to become a partner of YAME",
            step1: "Contact by phone",
            step2: "Qualification review",
            step3: "Communication affairs",
            step4: "Sign the contract",
            step5: "Training and Cooperation",
          },
          people: {
            title: "You Just bloom and leave the rest to us",
            desc: "Not letting down the beauty of the flowers, not letting down the good songs \n You are that beam of light. Join us and don't waste your youth",
          },
          onlineService: "Live Chat",
        },
        vi: {
          title: "Yame Live",
          hotRecruit: "Tuyển dụng hot",
          titleDesc:
            "Giao thông chính xác, kết nối hoạt động độc quyền, hoạt động thông minh, tỷ lệ giảm giá siêu cao. Tham gia hệ sinh thái Yame và tạo ra khả năng không giới hạn.",
          contactUs: "Liên hệ",
          recruitingAnchors: "Tuyển dụng MC",
          recruitingGuild: "Tuyển dụng Hội",
          agentCooperation: "Hợp tác đại lý",
          tab1: {
            desc: "Hoàn trả siêu cao & đảm bảo lượng người mới & ưu tiên anchor",
            secTitle:
              "Chính sách hoàn trả hàng đầu ngành, đảm bảo thu nhập cho anchor, ưu tiên hiển thị lưu lượng cho anchor mới, khởi động nhanh chóng",
            thirdTitle1: "Mô Hình Hợp Tác Của Streamer",
            thirdContent1:
              "· Chủ động liên hệ tham gia: Nhận hỗ trợ tài nguyên.",
            thirdTitle2: "Hỗ trợ dành cho Streamer:",
            thirdContent2:
              "· Hỗ trợ traffic: Được đề xuất và tiếp cận nguồn lực hiển thị.",
            thirdContent3:
              "· Hỗ trợ đào tạo: Hướng dẫn kỹ năng livestream và sáng tạo nội dung.",
          },
          tab2: {
            desc: "Lượng người dùng khổng lồ & chia sẻ hoa hồng nhóm & hỗ trợ vận hành chuyên biệt",
            secTitle:
              "Lượng người dùng khổng lồ với đề xuất chính xác, tăng fan liên tục và hiệu quả, công hội càng lớn thì thu nhập càng cao",
            thirdTitle1: "Mô Hình Hợp Tác Của Guild",
            thirdContent1:
              "· Chủ động liên hệ tham gia: Đăng ký hàng loạt và quản lý streamer trong guild, hưởng chính sách ưu đãi và nguồn lực riêng từ nền tảng.",
            thirdTitle2: "Hỗ trợ dành cho Guild:",
            thirdContent2:
              "· Chia sẻ doanh thu cao: Tỷ lệ chia sẻ lợi nhuận riêng cho nhóm.",
            thirdContent3:
              "· Ưu tiên xét duyệt: Phê duyệt nhanh streamer mới và ưu tiên tham gia sự kiện.",
          },
          tab3: {
            desc: "Phổ cập lưu lượng & chia sẻ hoa hồng nhóm & hỗ trợ vận hành chuyên biệt",
            secTitle:
              "Công hội càng lớn thì thu nhập càng cao. Hỗ trợ vận hành 1:1 chuyên biệt cho các tổ chức chất lượng, giải quyết vấn đề hàng ngày nhanh chóng",
            thirdTitle1: "Mô Hình Hợp Tác Của Đại Lý",
            thirdContent1:
              "· Chủ động liên hệ tham gia: Đăng ký hàng loạt và quản lý streamer dưới đại lý, hưởng chính sách ưu đãi và nguồn lực riêng từ nền tảng.",
            thirdTitle2: "Hỗ trợ dành cho Đại Lý:",
            thirdContent2:
              "· Chia sẻ doanh thu cao: Nhận hoàn tiền khi đạt mục tiêu doanh thu.",
            thirdContent3:
              "· Ưu tiên xét duyệt: Phê duyệt nhanh streamer mới và ưu tiên tham gia sự kiện.",
          },
          youshi: {
            title: "Lợi thế của chúng ta",
            advantage1: "Khung hợp tác đầy đủ",
            advantage1Desc:
              "Giao dịch tự động giải quyết, tự động chơi vào tài khoản, giải quyết một cách an toàn",
            advantage2: "Khả năng R&D ứng dụng",
            advantage2Desc:
              "Đội ngũ R&D do nhân viên từ doanh nghiệp lớn tạo thành, sở hữu công sức R&D mạnh mẽ.",
            advantage3: "Với các nguồn lực",
            advantage3Desc:
              "Có rất nhiều tài nguyên Internet, giúp các đối tác xuất sắc phát triển nhanh chóng, đạt được win-win",
          },
          partner: {
            title: "Các đối tác yêu cầu",
            partner1: "Ý tưởng phù hợp",
            partner1Desc:
              "Tán thành với giá trị sản phẩm và triết lý văn hóa của Yame, sẵn sàng hợp tác dài",
            partner2: "Các doanh nghiệp",
            partner2Desc:
              "Các đối tác cần phải có uy tín kinh doanh và tiếng nói tốt và là doanh nghiệp chính thức",
            partner3: "Kinh nghiệm",
            partner3Desc:
              "Với một số kinh nghiệm trong ngành công nghiệp truyền thông mới và tham gia vào nó",
            partner4: "Nguồn tài nguyên",
            partner4Desc:
              "Có nguồn cung cấp hoặc có nguồn cung cấp cho người neo",
          },
          how: {
            title: "Làm thế nào để trở thành cộng sự của YAME",
            step1: "Ứng dụng liên lạc",
            step2: "Đánh giá trình độ",
            step3: "Đàm phán hợp tác",
            step4: "Ký hợp tác",
            step5: "Đào tạo và hợp tác",
          },
          people: {
            title: "Cứ nở đi, để chúng tôi lo phần còn lại!",
            desc: "Không có vẻ đẹp, không có bài hát tốt, không có tư thế đẹp. \n Bạn là ánh sáng đó, tham gia với chúng tôi, không phải là thanh thiếu niên không phải là bạn",
          },
          onlineService: "Liên hệ",
        },
      },
      lang: "en",
      active: 0,
      headList: [
        {
          img: require("@/assets/images/head5.png"),
        },
        {
          img: require("@/assets/images/head1.png"),
          text: "Xin chào",
          style2: true,
        },
        {
          img: require("@/assets/images/head6.png"),
          text: "Hello!~",
        },
        {
          img: require("@/assets/images/head9.png"),
          voice: 15,
        },
        {
          img: require("@/assets/images/head10.png"),
          text: "Hello Bro",
          style2: true,
        },
        {
          img: require("@/assets/images/head2.png"),
          text: "Bonjour",
        },
        {
          img: require("@/assets/images/head3.png"),
          text: "สวัสดี",
        },
        {
          img: require("@/assets/images/head4.png"),
        },
        {
          img: require("@/assets/images/head11.png"),
          text: "Hola！",
        },
        {
          img: require("@/assets/images/head8.png"),
        },
        {
          img: require("@/assets/images/head7.png"),
        },
      ],
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.lang = localStorage.getItem("lang") || "en";
    },
    changeLan(lang) {
      console.log(lang);
      this.lang = lang;
      localStorage.setItem("lang", lang);
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: "Poppins-Bold";
  src: url("../assets/font/Poppins-Bold.ttf");
}
@font-face {
  font-family: "Poppins-Medium";
  src: url("../assets/font/Poppins-Medium.ttf");
}
@font-face {
  font-family: "Poppins-Regular";
  src: url("../assets/font/Poppins-Regular.ttf");
}
@font-face {
  font-family: "Poppins-SemiBold";
  src: url("../assets/font/Poppins-SemiBold.ttf");
}

.commonCardWidth {
  /* width: 100%; */
  /* padding: 0 240px; */
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 120px;
  @media screen and (max-width: 1920px) {
    padding: 0 240px;
  }
  @media screen and (max-width: 1680px) {
    padding: 0 220px;
  }
  @media screen and (max-width: 1440px) {
    padding: 0 100px;
  }
  @media screen and (max-width: 1300px) {
    padding: 0 80px;
  }
  @media screen and (max-width: 768px) {
    padding: 0 20px;
  }
}

.container {
  width: 100%;
  min-height: 100vh;
  background-color: #f8f8f8;
  box-sizing: content-box;
  /* @media screen and (max-width: 768px) {
    padding-bottom: 100px;
  } */
}
.header {
  /* width: 100%; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 190px;
  @media screen and (max-width: 768px) {
    height: 50px;
  }
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
}
.languageContainer {
  border: 1px solid #000;
  border-radius: 99px;
  width: 108px;
  height: 47px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  font-size: 18px;
  color: #000;
  @media screen and (max-width: 768px) {
    font-size: 13px;
    padding: 0 10px;
    width: 80px;
    height: 30px;
  }
}
.logo {
  width: 135px;
  @media screen and (max-width: 768px) {
    width: 80px;
  }
}
.commonPad {
  position: relative;
  width: 100%;
  .bgImg {
    width: 100%;
    display: block;
  }
}
.mobileShow {
  display: none !important;
  @media screen and (max-width: 768px) {
    display: block !important;
  }
}
.pcShow {
  display: block !important;
  @media screen and (max-width: 768px) {
    display: none !important;
  }
}

.card1 {
  color: #222;
  position: relative;
  box-sizing: border-box;
  margin-bottom: 50px;
  @media screen and (max-width: 768px) {
    margin-bottom: 20px;
  }
}
.cardBg1 {
  height: 100vh;
  width: 100%;
}
.leftArea {
  position: absolute;
  left: 0;
  right: 0;
  top: 27%;
  z-index: 10;
  @media screen and (max-width: 768px) {
    left: 0;
    right: 0;
    top: 80px;
    /* top: inherit; */
    bottom: 108px;
  }
}
.rightImg1 {
  position: absolute;
  right: 42px;
  top: 0;
  /* width: 50%; */
  height: 100%;
}
.rightImg2 {
  width: calc(100% + 40px);
  height: auto;
  display: block;
  margin-left: -20px;
}

.card1Width2 {
  width: 30%;
  @media screen and (max-width: 1920px) {
    width: 35%;
  }
  @media screen and (max-width: 1680px) {
    width: 40%;
  }
  @media screen and (max-width: 1440px) {
    width: 45%;
  }
  @media screen and (max-width: 1300px) {
    width: 50%;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
}
.cardContent {
  margin-bottom: 75px;
  font-size: 18px;
  color: #222;
  @media screen and (max-width: 768px) {
    margin-bottom: 15px;
    text-align: center;
    font-size: 14px;
    line-height: 20px;
  }
}
.titleText0 {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 10px;
  @media screen and (max-width: 768px) {
    font-size: 32px;
    margin-bottom: 13px;
    text-align: center;
  }
}
.titleText {
  background: linear-gradient(to right, #0067ff, #f03c24);
  -webkit-background-clip: text; /* Safari 和 Chrome 需要前缀 */
  background-clip: text;
  color: transparent; /* 关键：使文字透明以显示背景 */
  font-weight: bold;
  font-size: 64px;
  margin-bottom: 40px;
  @media screen and (max-width: 768px) {
    font-size: 30px;
    text-align: center;
    margin-bottom: 15px;
  }
}
.commonLine {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-size: 18px;
  height: 40px;
  @media screen and (max-width: 768px) {
    margin-bottom: 10px;
    font-size: 16px;
  }
}
.lineImg {
  margin-right: 19px;
  width: 40px;
  /* @media screen and (max-width: 768px) {
    width: 15px;
    margin-right: 10px;
  } */
}
.threeBox {
  border: 3px solid #e7e7e7;
  padding: 18px 20px;
  text-align: center;
  border-radius: 29px;
  cursor: pointer;
  height: 239px;

  @media screen and (max-width: 768px) {
    padding: 5px 10px;
    border: none;
    height: auto;
  }
}
.boxTitle {
  font-size: 24px;
  line-height: 32px;
  font-weight: bold;
  margin-bottom: 9px;
  @media screen and (max-width: 768px) {
    font-size: 12px;
    line-height: 1;
    color: #999999;
  }
}
.boxDesc {
  font-size: 16px;
  color: #999;
  /* @media screen and (max-width: 768px) {
    font-size: 10px;
  } */
}
.active {
  /* border-image: linear-gradient(45deg, #4176f0, #72c2ff) 1; */
  border: 3px solid #4176f0;
  border-radius: 29px;
  background-color: #fff;
  @media screen and (max-width: 768px) {
    border: 0;
    background-color: inherit;
  }
}
.active .boxDesc {
  color: #2976e8;
}
.active .boxTitle {
  @media screen and (max-width: 768px) {
    color: #222;
  }
}
.boxImg {
  display: block;
  margin: 0 auto 6px;
  width: 120px;
  height: 120px;
  @media screen and (max-width: 768px) {
    width: 100%;
    height: auto;
    /* height: 40px; */
  }
}
.padBody {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* 配套bigDesc */
.bigTitle0 {
  font-size: 40px;
  font-weight: bold;
  padding-top: 100px;
  margin-bottom: 29px;
  text-align: center;
  @media screen and (max-width: 768px) {
    font-size: 24px;
    padding: 0 20px;
    padding-top: 40px;
    margin-bottom: 12px;
  }
}
.bigTitle {
  font-size: 40px;
  font-weight: bold;
  padding-top: 100px;
  margin-bottom: 80px;
  text-align: center;
  @media screen and (max-width: 768px) {
    font-size: 24px;
    padding: 0 20px;
    padding-top: 40px;
    margin-bottom: 28px;
  }
}
.bigDesc {
  color: #666;
  font-size: 18px;
  text-align: center;
  margin-top: 32px;
  margin-bottom: 31px;
  /* @media screen and (max-width: 1680px) {
    font-size: 24px;
  }
  @media screen and (max-width: 1440px) {
    font-size: 20px;
  }
  @media screen and (max-width: 1300px) {
    font-size: 16px;
  } */
  @media screen and (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 15px;
    padding: 0 30px;
  }
}
.bigDesc0 {
  color: #666;
  font-size: 18px;
  text-align: center;
  margin-top: 32px;
  margin-bottom: 31px;
  @media screen and (max-width: 768px) {
    font-size: 12px;
    margin-bottom: 15px;
    padding: 0 30px;
  }
}
.tabBody {
  display: flex;
  align-items: center;
  @media screen and (max-width: 768px) {
    display: block;
  }
}
.tabBigImg {
  width: 50%;
  margin-right: 113px;
  @media screen and (max-width: 768px) {
    margin-right: 0;
    width: 100%;
    margin-bottom: 20px;
  }
}
.tabBodyRight {
  flex: 1;
}
.rightItem {
  margin-bottom: 60px;
  @media screen and (max-width: 768px) {
    margin-bottom: 20px;
  }
}
.tabBodyTitle {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 16px;
  @media screen and (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 8px;
  }
}
.tabBodyText {
  color: #666;
  font-size: 16px;
  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
}

.ourAdvantage {
  background: linear-gradient(45deg, #f2f9ff, #eaf6ff);
  margin-top: 100px;
  padding-bottom: 100px;
  @media screen and (max-width: 768px) {
    margin-top: 53px;
    padding-bottom: 40px;
  }
}
.advantageItem {
  position: relative;
  @media screen and (max-width: 768px) {
    margin-bottom: 12px;
  }
}
.partnerRequire {
  padding-bottom: 100px;
  @media screen and (max-width: 768px) {
    padding-bottom: 40px;
  }
}
.advImg {
  width: 100%;
}
.advBody {
  position: absolute;
  top: 35px;
  left: 24px;
  z-index: 10;
  @media screen and (max-width: 768px) {
    top: 15px;
    width: 57%;
  }
}
.advBody2 {
  @media screen and (max-width: 768px) {
    left: inherit;
    right: 10px;
  }
}

.advantageTitle {
  font-size: 28px;
  font-weight: bold;
  color: #0067ff;
  margin-bottom: 20px;
  @media screen and (max-width: 768px) {
    font-size: 16px;
    line-height: 32px;
    color: #222;
    margin-bottom: 6px;
  }
}
.advantageDesc {
  display: inline-block;
  width: 60%;
  font-size: 16px;
  color: #666;
  line-height: 32px;
  @media screen and (max-width: 768px) {
    font-size: 12px;
    line-height: 20px;
    letter-spacing: -0.4px;
    width: 100%;
  }
}
.partnerBody {
  position: absolute;
  left: 35%;
  top: 40px;
  z-index: 10;
  @media screen and (max-width: 768px) {
    left: 17px;
    top: 16px;
    width: 52%;
  }
}
.partnerBody2 {
  @media screen and (max-width: 768px) {
    left: inherit;
    right: 10px;
  }
}
.partnerTitle {
  color: #222;
  font-weight: bold;
  font-size: 24px;
  margin-bottom: 8px;
  @media screen and (max-width: 768px) {
    line-height: 32px;
    margin-bottom: 6px;
    font-size: 16px;
  }
}
.partnerDesc {
  font-size: 16px;
  color: #666;
  line-height: 32px;
  @media screen and (max-width: 768px) {
    font-size: 12px;
    line-height: 20px;
    letter-spacing: -0.4px;
  }
}
.partnerRow {
  margin-bottom: 30px;
  @media screen and (max-width: 768px) {
    margin-bottom: 14px;
  }
}
.partnerItem {
  position: relative;
  border-radius: 20px;
  background-color: #fff;
  overflow: hidden;
}
.partnerItem2 {
  @media screen and (max-width: 768px) {
    margin-bottom: 14px;
  }
}
.howToBePartner {
  background-color: #fff;
  padding-bottom: 130px;
  @media screen and (max-width: 768px) {
    padding-bottom: 40px;
  }
}
.howToBePartner .commonCardWidth {
  @media screen and (max-width: 768px) {
    padding: 0;
  }
}

.howPartnerBody {
  display: flex;
  flex-wrap: wrap;
  @media screen and (max-width: 768px) {
    justify-content: center;
  }
}
.partnerBox {
  width: 20%;
  text-align: center;
  @media screen and (max-width: 768px) {
    padding: 0 20px;
    box-sizing: border-box;
    width: 33%;
  }
}
.oneLine {
  height: 1px;
  background-color: #e7e7e7;
  width: 100%;
  margin: 20px;
}
.howImg {
  display: block;
  width: 50%;
  margin: 0 auto;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
}
.howPartnerTitle {
  font-size: 18px;
  font-weight: bold;
  @media screen and (max-width: 768px) {
    font-size: 14px;
    font-weight: normal;
  }
}

.peopleBody {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  @media screen and (max-width: 768px) {
    top: 40%;
  }
}
.avatarImg {
  @media screen and (max-width: 768px) {
    width: 44px !important;
    height: 44px !important;
  }
}
.avatar {
  position: absolute;
  /* right: 50%;
  top: 50%;
  transform: translateY(-50%); */
  border-radius: 50%;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #1f1f1f;
  > img {
    width: 76px;
  }
  &:hover {
    transform: scale(1.2);
  }
}

/* 应用动画到头像 */
.avatar-1 {
  left: 10%;
  top: 49%;
  img {
    width: 88px;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
}

.avatar-2 {
  left: 27%;
  top: 56%;
  @media screen and (max-width: 768px) {
    display: none;
  }
}

.avatar-3 {
  left: 50%;
  top: 39%;
  margin-left: -60px;
  img {
    width: 95px;
  }
  @media screen and (max-width: 768px) {
    left: inherit;
    top: 14%;
    right: 32%;
  }
}

.avatar-4 {
  right: 25%;
  top: 51%;
  @media screen and (max-width: 768px) {
    left: 79px;
    top: 25%;
    right: inherit;
    transform: scale(1.1);
  }
}

.avatar-5 {
  right: 5%;
  top: 45%;
  img {
    width: 96px;
  }
  @media screen and (max-width: 768px) {
    top: inherit;
    right: 5%;
    bottom: 21%;
  }
}

.avatar-6 {
  left: 13%;
  bottom: 25%;
}

.avatar-7 {
  left: 30%;
  bottom: 8%;
  img {
    width: 122px;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
}

.avatar-8 {
  left: 45%;
  bottom: 22%;
  img {
    width: 140px;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
}

.avatar-9 {
  right: 30%;
  bottom: 25%;
  img {
    width: 95px;
  }
  @media screen and (max-width: 768px) {
    right: 50%;
    bottom: 62px;
    transform: scale(0.8);
  }
}

.avatar-10 {
  right: 17%;
  bottom: 15%;
  img {
    width: 108px;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
}
.avatar-11 {
  right: 5%;
  bottom: 15%;
  img {
    width: 71px;
  }
  @media screen and (max-width: 768px) {
    right: 10%;
    top: 23%;
    bottom: inherit;
  }
}

.footer {
  background-color: #35363c;
  font-size: 16px;
  @media screen and (max-width: 768px) {
    height: 60px;
    font-size: 13px;
  }
}
.footerBody {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  height: 102px;
  @media screen and (max-width: 768px) {
    height: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Recruit.vue